module.exports = __webpack_public_path__ + "img/pencil-filters_en.a7a6399.jpg";